import { useRouter } from 'next/router';

export default function ForceSSRLink({ href, children, prefetch, ...props }) {
    return (
        <a
            href={href}
            onClick={(e) => {
                e.preventDefault();
                window.location.href = href;
            }}
            {...props}
        >
            {children}
        </a>
    );
}
